export const LANDING_ACTIONS = {
  ADD_TO_CART: 'ADD_TO_CART',
  VISIT_CART_PAGE: 'VISIT_CART_PAGE',
  CONTACT_CONSULTANT: 'CONTACT_CONSULTANT',
};
